import { SettingsRoutes } from 'pages/settings/route/type'
import { TeamsRoutes } from 'pages/settings/pages/teams/route/type'

const teams = `/${SettingsRoutes.root}/${TeamsRoutes.root}`

export const TeamsPath = {
  root: teams,
  create: `${teams}/${TeamsRoutes.create}`,
  getManage: (teamId: number) =>
    `${teams}/${TeamsRoutes.manage.replace(':teamId', String(teamId))}`,
}
